export class UniqError {
  constructor(eventId, message, statusCode, url = '', data = '') {
    this.id = eventId
    this.message = message
    this.statusCode = statusCode
    this.url = url
    this.data = data
  }
}
